"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _authenticate = require("../../mixins/authenticate");

var _authenticate2 = _interopRequireDefault(_authenticate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  /**
   * Mixins
   */
  mixins: [_authenticate2.default],

  /**
   * Component created hook
   */
  created: function created() {
    this.sid = this.getSidFromUrl();
  },


  /**
   * Mounted
   */
  mounted: function mounted() {
    if (this.sid) {
      this.setSameDeviceMode();
      this.isLoading = true;
      this.currentTries = this.defaultTries;
      this.startAuthCheck();
    } else if (!this.isMobile()) {
      this.authenticate();
    }
  },


  /**
   * Methods
   */
  methods: {
    /**
     * Start authentication
     */
    authenticate: function authenticate() {
      if (this.isSigning) {
        return;
      }

      this.currentTries = this.defaultTries;
      this.startSigning();
      this.startAuthCheck();
    },


    /**
     * Start auth on same device
     */
    authSameDevice: function authSameDevice() {
      this.setSameDeviceMode();
      this.authenticate();
    },


    /**
     * Start auth on another device
     */
    authAnotherDevice: function authAnotherDevice() {
      this.setAnotherDeviceMode();
      this.authenticate();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/LoginFormBankId.vue
// module id = 7wZj
// module chunks = 0 1